export const SET_ACTIVE_STEP = "SET_ACTIVE_STEP";
export const SET_BUTTON_ACTIVE = "SET_BUTTON_ACTIVE";
